import React, { lazy, Suspense, useState } from "react";
import Loader from "../../common/Loader";
// Chargés à la demande : la chaîne @react-pdf pèse plus de la moitié du bundle.
const FormViewerPdf = lazy(() => import("../FormRDSP/FormViewerPdf"));
const CERPrint = lazy(() => import("../CERPrint/CERPrint"));

// Documents de l'allocataire : réponses au questionnaire d'orientation (RDO)
// et contrat d'engagement réciproque (CER), chacun expliqué en une phrase.
const MesDocuments = ({ reponses, allocataire }) => {
  const [showRdo, setShowRdo] = useState(false);
  const [showCer, setShowCer] = useState(false);

  return (
    <div className="documents">
      {reponses && (
        <div className="document">
          <div className="document__texte">
            <strong>Vos réponses au questionnaire d'orientation (RDO)</strong>
            <p>Le document reprend toutes vos réponses. Vous pouvez le garder ou l'imprimer.</p>
          </div>
          {showRdo ? (
            <Suspense fallback={<Loader />}>
              <FormViewerPdf form={reponses.config} answers={reponses.rdsp} recipient={allocataire} />
            </Suspense>
          ) : (
            <button type="button" className="btn btn-ghost doc-rdo" onClick={() => setShowRdo(true)}>
              <i className="fa fa-download mr-2" aria-hidden="true" />
              Télécharger mes réponses (PDF)
            </button>
          )}
        </div>
      )}
      <div className="document">
        <div className="document__texte">
          <strong>Votre contrat d'engagement réciproque (CER)</strong>
          <p>Le contrat établi avec votre référent, s'il existe déjà.</p>
        </div>
        {showCer ? (
          <Suspense fallback={<Loader />}>
            <CERPrint recipient={allocataire} />
          </Suspense>
        ) : (
          <button type="button" className="btn btn-ghost doc-cer" onClick={() => setShowCer(true)}>
            <i className="fa fa-file-alt mr-2" aria-hidden="true" />
            Consulter mon contrat (CER)
          </button>
        )}
      </div>
    </div>
  );
};

export default MesDocuments;
